import { Injectable } from '@angular/core';
import { LU_InvoiceBatchServiceBase } from 'scaletech-invoices';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_InvoiceBatchService extends LU_InvoiceBatchServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
